import React, { useState, useEffect } from 'react';
import { Menu, X, Phone, Mail } from 'lucide-react';
import { Button } from './ui/button';

const Header = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const navLinks = [
    { name: 'Home', href: '#home' },
    { name: 'About', href: '#about' },
    { name: 'Services', href: '#services' },
    { name: 'Clients', href: '#clients' },
    { name: 'Careers', href: '#careers' },
    { name: 'Contact', href: '#contact' },
  ];

  const scrollToSection = (href) => {
    const element = document.querySelector(href);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
    setIsMobileMenuOpen(false);
  };

  return (
    <>
      {/* Top Bar */}
      <div className="bg-gradient-to-r from-shsTeal to-shsBlue text-white py-2 px-4 text-sm hidden md:block">
        <div className="max-w-7xl mx-auto flex justify-between items-center">
          <div className="flex items-center gap-6">
            <a href="tel:0457802302" className="flex items-center gap-2 hover:text-shsGold transition-colors">
              <Phone size={14} />
              <span>0457 802 302</span>
            </a>
            <a href="mailto:Info@supremehospitalitysolutions.com" className="flex items-center gap-2 hover:text-shsGold transition-colors">
              <Mail size={14} />
              <span>Info@supremehospitalitysolutions.com</span>
            </a>
          </div>
          <div className="text-shsGold font-medium">
            Elevating Your Guest Experience
          </div>
        </div>
      </div>

      {/* Main Header */}
      <header
        className={`sticky top-0 z-50 transition-all duration-300 ${
          isScrolled
            ? 'bg-white/95 backdrop-blur-md shadow-lg'
            : 'bg-white'
        }`}
      >
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex justify-between items-center h-20">
            {/* Logo */}
            <a href="#home" className="flex items-center gap-3 group">
              <img
                src="https://customer-assets.emergentagent.com/job_c12dcee6-cb25-472a-a8d9-3fec8b95d54b/artifacts/qydms074_base_logo_transparent_background.png"
                alt="Supreme Hospitality Solutions"
                className="h-16 w-auto transition-transform duration-300 group-hover:scale-105"
              />
            </a>

            {/* Desktop Navigation */}
            <nav className="hidden lg:flex items-center gap-1">
              {navLinks.map((link) => (
                <button
                  key={link.name}
                  onClick={() => scrollToSection(link.href)}
                  className="px-4 py-2 text-shsNavy font-medium hover:text-shsTeal transition-colors relative group"
                >
                  {link.name}
                  <span className="absolute bottom-0 left-1/2 -translate-x-1/2 w-0 h-0.5 bg-shsTeal transition-all duration-300 group-hover:w-3/4" />
                </button>
              ))}
            </nav>

            {/* CTA Button */}
            <div className="hidden lg:block">
              <Button
                onClick={() => scrollToSection('#contact')}
                className="bg-shsTeal hover:bg-shsBlue text-white px-6 py-2 rounded-full transition-all duration-300 hover:shadow-lg hover:shadow-shsTeal/20"
              >
                Get Started
              </Button>
            </div>

            {/* Mobile Menu Button */}
            <button
              className="lg:hidden p-2 text-shsNavy hover:text-shsTeal transition-colors"
              onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
            >
              {isMobileMenuOpen ? <X size={28} /> : <Menu size={28} />}
            </button>
          </div>
        </div>

        {/* Mobile Menu */}
        <div
          className={`lg:hidden overflow-hidden transition-all duration-300 ${
            isMobileMenuOpen ? 'max-h-96 border-t border-gray-100' : 'max-h-0'
          }`}
        >
          <nav className="px-4 py-4 bg-white space-y-1">
            {navLinks.map((link) => (
              <button
                key={link.name}
                onClick={() => scrollToSection(link.href)}
                className="block w-full text-left px-4 py-3 text-shsNavy font-medium hover:bg-shsTeal/5 hover:text-shsTeal rounded-lg transition-colors"
              >
                {link.name}
              </button>
            ))}
            <div className="pt-4">
              <Button
                onClick={() => scrollToSection('#contact')}
                className="w-full bg-shsTeal hover:bg-shsBlue text-white rounded-full"
              >
                Get Started
              </Button>
            </div>
          </nav>
        </div>
      </header>
    </>
  );
};

export default Header;
